<template>
  <details name="faq" class="faq__card-details">
    <summary class="faq__card-summary">
      <span>{{ content.question }}</span>

      <span class="faq__card-button">
        <Icon id="arrow" class="faq__card-icon" />
      </span>
    </summary>

    <div class="faq__card-content">
      <p>{{ content.answer }}</p>
    </div>
  </details>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'FaqCard',
  components: { Icon },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
